import Timerbox from "./Timer";
import crossbtn from '../home/images/close-btn.svg';
import PropTypes from 'prop-types';

const Header = (props) => {
    return (
        <>
            <Timerbox strike={props.strike} round={props.round} invalidmsg={props.invalidmsg} />
        </>
    );
};

Header.propTypes = {
    strike: PropTypes.number.isRequired,
    round: PropTypes.number.isRequired,
    invalidmsg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) // Allow both string and number
};

const ScoreChart = ({ show, close }) => {
    const modalPoint = [
        { id: 1, points: 1, letters: "A, E, I, O, U, L, N, S, T, R" },
        { id: 2, points: 2, letters: "D, G" },
        { id: 3, points: 3, letters: "B, C, M, P" },
        { id: 4, points: 4, letters: "F, H, V, W, Y" },
        { id: 5, points: 5, letters: "K" },
        { id: 6, points: 8, letters: "J, X" },
        { id: 7, points: 10, letters: "Q, Z" }
    ];

    return (
        <div className='wordModal'>
            <div className={`modal ${show ? 'show' : ''}`} onClick={close}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="modal-title">Point Chart</h4>
                        <button className="close-button" onClick={close}><img src={crossbtn} alt="close button" /></button>
                    </div>
                    <div className="modal-body">
                        <div className="modalContent">
                            <div className="contHeading"><h3>Points</h3></div>
                            <div className="wordName"><h3>Letters</h3></div>
                        </div>
                        {modalPoint.map((item, i) => (
                            <div className="modalContent modal-score" key={i}>
                                <div className="point-box"><h3>{item.points}</h3></div>
                                <div className="word-box"><h3>{item.letters}</h3></div>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button onClick={close}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ScoreChart.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

const GameHistoryModal = ({ show, close }) => {
    const Gamewin = [
        { id: 1, winlose: "Win", Score: 23 },
        { id: 2, winlose: "Lose", Score: 15 },
        { id: 3, winlose: "Win", Score: 20 },
        { id: 4, winlose: "Win", Score: 23 },
        { id: 5, winlose: "Lose", Score: 0 }
    ];

    return (
        <div className="game-history game-modal-history">
            <div className={`modal ${show ? 'show' : ''}`} onClick={close}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="modal-title">Game History</h4>
                        <button className="close-button" onClick={close}><img src={crossbtn} alt="close button" /></button>
                    </div>
                    <div className="modal-body">
                        <div className="modalContent">
                            <div className="contHeading"><h3>Win/Lose</h3></div>
                            <div className="wordName"><h3>Score</h3></div>
                        </div>
                        {Gamewin.map((itm) => (
                            <div className="modalContent modal-score" key={itm.id}>
                                <div className="point-box"><h3>{itm.winlose}</h3></div>
                                <div className="word-box"><h3>{itm.Score}</h3></div>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer">
                        <button onClick={close}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

GameHistoryModal.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

export default Header;
export { GameHistoryModal, ScoreChart };